import { api_GET, api_POST_FORM, api_PUT_FORM, api_DELETE } from "./_api.js";

// O PDF vai como arquivo no multipart; "arquivo" é o nome do .zip já gravado
// (mantido na alteração quando não há upload novo, vazio remove).
const montarFormData = (regraVersao, arquivoUpload) => {
    const formData = new FormData();
    ["id", "titulo", "descricao", "dataPublicacao", "categoria", "status", "arquivo"].forEach(campo => {
        const valor = regraVersao[campo];
        if (valor !== null && valor !== undefined)
            formData.append(campo, valor);
    });

    if (arquivoUpload)
        formData.append("arquivoUpload", arquivoUpload);

    return formData;
};

const regraVersaoSistema_api = {
    // Listagem completa (inclui itens inativos) — tela de cadastro
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("RegraVersaoSistema")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    // Somente itens publicados — tela de consulta
    getListAtivos: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("RegraVersaoSistema/GetListAtivos")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RegraVersaoSistema/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }, 
    getListPublica: (secretaria_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RegraVersaoSistema/GetListPublica${secretaria_Id ? `/${secretaria_Id}` : ""}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItemByHash: (hash) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RegraVersaoSistema/GetItemByHash/${hash}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (regraVersao, arquivoUpload) => {
        const promise = new Promise((resolve, reject) => {
            api_POST_FORM("RegraVersaoSistema", montarFormData(regraVersao, arquivoUpload))
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (regraVersao, arquivoUpload) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT_FORM("RegraVersaoSistema", montarFormData(regraVersao, arquivoUpload))
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    delete: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`RegraVersaoSistema/Delete/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default regraVersaoSistema_api;
